<template>
  <v-container v-if="$auth.may(['audit:finish'])">
    <v-app-bar app dark dense color="secondary">
      <v-app-bar-title>{{ $t("auditor.options.title") }}</v-app-bar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12" md="6">
        <BookingDeadlineForm />
      </v-col>

      <v-col cols="12" md="6">
        <PrecheckBookingDeadlineForm />
      </v-col>

      <v-col cols="12" md="6">
        <StartEditForm />
      </v-col>

      <v-col cols="12" md="6">
        <AuditPeriodClosedAtForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BookingDeadlineForm from "@/components/Options/BookingDeadlineForm.vue";
import PrecheckBookingDeadlineForm from "@/components/Options/PrecheckBookingDeadlineForm.vue";
import StartEditForm from "@/components/Options/StartEditForm.vue";
import AuditPeriodClosedAtForm from "@/components/Options/AuditPeriodClosedAtForm.vue";

export default {
  data() {
    return {};
  },

  components: {
    BookingDeadlineForm,
    PrecheckBookingDeadlineForm,
    StartEditForm,
    AuditPeriodClosedAtForm,
  },
};
</script>
